import _taggedTemplateLiteralLoose from '@babel/runtime/helpers/esm/taggedTemplateLiteralLoose';
import styled, { css } from '@xstyled/styled-components';
import { getVariantColor } from '@trybeapp/ui.utilities';
import { HtmlDiv } from '@trybeapp/ui.elements';
import { th } from '@xstyled/system';

var _templateObject;
var Hint = /*#__PURE__*/styled(HtmlDiv)(function (_ref) {
  var variant = _ref.variant;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      ", ";\n      color: ", ";\n      margin-top: ", ";\n      display: flex;\n      align-items: center;\n    "])), th('fields.hint'), getVariantColor(variant), th('space.sm'));
});
Hint.displayName = 'Hint';

export { Hint };
